import { useState, useEffect } from 'react';
import { trackCTAClick } from '@/lib/analytics';
import { useTranslation } from 'react-i18next';
import { LanguageToggle } from '@/components/LanguageToggle';

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  el.scrollIntoView({ behavior: prefersReduced ? 'instant' : 'smooth', block: 'start' });
};

export const StickyNav = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      data-testid="sticky-nav"
      className="fixed top-0 left-0 right-0 z-[100] transition-transform duration-300"
      style={{
        transform: visible ? 'translateY(0)' : 'translateY(-100%)',
        backgroundColor: 'rgba(7,21,37,0.92)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
      }}
    >
      <div className="px-4 sm:px-12 lg:px-16 h-14 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img
            src="/images/logo.png"
            alt="Verse Clinic"
            className="h-8"
            style={{ display: 'block' }}
          />
          <div className="hidden sm:flex items-center gap-2">
            <span
              className="text-xs"
              style={{ color: 'var(--vc-fg-subtle)', fontFamily: 'Inter, sans-serif' }}
            >
              {t('sticky.prelaunch')}
            </span>
            <span
              className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium"
              style={{
                backgroundColor: 'rgba(214,168,74,0.15)',
                color: 'var(--vc-gold)',
                border: '1px solid rgba(214,168,74,0.25)',
                fontFamily: 'Inter, sans-serif',
              }}
            >
              {t('sticky.limited')}
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2 sm:gap-3">
          <LanguageToggle />
          <button
            onClick={() => {
              trackCTAClick('sticky_nav_cta');
              scrollToSection('waitlist');
            }}
            className="inline-flex items-center h-8 sm:h-9 px-3 sm:px-5 text-[11px] sm:text-xs font-medium rounded-lg transition-colors duration-200 active:scale-[0.98] whitespace-nowrap"
            style={{
              backgroundColor: 'var(--vc-gold)',
              color: 'var(--vc-ink)',
              fontFamily: 'Inter, sans-serif',
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--vc-gold-2)'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'var(--vc-gold)'}
          >
            {t('sticky.join')}
          </button>
        </div>
      </div>
    </div>
  );
};
